// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ld-0";
export var fileList = "_ld-2";
export var removeFileButton = "_ld-1";